
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FileDownloadModel, PrintPlanItemRequestOptions } from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import NDialog from '@/libs/common/components/NDialog.vue';

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512): Blob => {
    const byteCharacters = atob(b64Data);
    const byteArrays: Uint8Array[] = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
};

@Component({
    components: { NDialog },
})
export default class WorkTaskPrintButton extends Vue {
    @Prop({ required: true }) id!: string;
    @Prop({ default: true }) visible!: boolean;

    printing = false;
    printDialog = false;
    printOptions: PrintPlanItemRequestOptions = {};

    get isMobile(): boolean {
        return this.$vuetify.breakpoint.width < 576;
    }

    openPrintDialog() {
        this.printDialog = true;
    }

    onPrintClick() {
        this.printPlanItem();
    }

    private printPlanItem() {
        this.printing = true;
        ApiService.api
            .printPlanItemById(this.id, this.printOptions)
            .then((e: any) => {
                this.printing = false;
                const res = e.data.returnValue as FileDownloadModel;
                const blob = b64toBlob(res.base64!, res.contentType!);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', res.filename!);
                document.body.appendChild(link);
                link.click();
                link.parentNode!.removeChild(link);
                this.printDialog = false;
            })
            .catch(() => {
                this.printing = false;
            });
    }
}
